import {Component, signal} from '@angular/core';

@Component({
    selector: 'app-root',
    standalone: false,
    template: '<router-outlet></router-outlet>',
    styles: [':host { display: block; height: 100%; }']
})
export class AppComponent {
    protected readonly title = signal('web-sigevs');

    constructor() {
    }
}
